import { FunctionComponent, ComponentProps } from 'react';
import styled, { StyledComponent } from 'styled-components';
import { InstantConfirm } from '@lt/components/icons-react/userflow';
import { CurrencyFormat } from '@lt/components';
import { PackageHotPrice } from '../PackageHotPrice';

export const StyledInstantConfirm = styled(InstantConfirm)`
  width: 11px;
  height: 22px;
  margin-right: 4px;
`;

export const FullPrice: StyledComponent<
  FunctionComponent<ComponentProps<typeof CurrencyFormat> & { onClick?: () => void }>,
  any,
  any,
  never
> = styled(CurrencyFormat)`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 1.125em;
  line-height: 1.375em;

  color: #17181a;
  cursor: pointer;
`;

export const PriceBlock = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const StyledPackageHotPrice = styled(PackageHotPrice)`
  margin-left: 8px;
`;

export const PriceDroppedIcon = styled.div`
  width: 0;
  height: 0;
  border-width: 9px 6px 0 6px;
  border-color: #6abf40 transparent transparent transparent;
  border-style: solid;
  margin-right: 4px;
`;

export const PriceGrowIcon = styled.div`
  width: 0;
  height: 0;
  border-width: 0 6px 9px 6px;
  border-color: transparent transparent #d0021b transparent;
  border-style: solid;
  margin-right: 4px;
`;

export const PriceMovementView = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const PriceDifference: typeof CurrencyFormat = styled(CurrencyFormat)`
  margin-left: 4px;
`;
